module.exports = __webpack_public_path__ + "static/pinkbunny3-5df219ec4e534d45fb8c0af31b685f68.png";